import { Component, output } from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideX } from '@ng-icons/lucide';

@Component({
  selector: 'app-modal',
  imports: [NgIcon],
  viewProviders: [provideIcons({ lucideX })],
  templateUrl: './modal.component.html',
  styles: ``,
})
export class ModalComponent {
  closeModal = output<void>();

  close() {
    this.closeModal.emit();
  }
}
